import { iframeDownload, useIframeDownload, withIframeDownload } from './src/iframe-download';
import { download } from './src/index';
import { downloadify, downloadifyBlob } from './src/downloadify';


export {
  iframeDownload,
  useIframeDownload,
  withIframeDownload,
  download,
  downloadifyBlob,
  downloadify
};
